module.exports = __webpack_public_path__ + "img/16.f37b6b5c.png";